import React, { Component } from 'react';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import { print } from 'react-icons-kit/fa/print';
import moment from 'moment';
import { Table } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { convokePlacesOption, healthFacilitiesGetCriterial, htmlTemplatesPrintResultsInBulk, labSectionsByHf, printingBlock, functionalCriterial } from '../../../libs/services';
import Help from '../../generics/help';
import ModalFileType from '../../results_donation/components/modalFileType';

class PrintingBlock extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.dateCompare = this.dateCompare.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.showSectionsPrint = this.showSectionsPrint.bind(this);
     
        this.state = {
            search_type:'date',
            start_date:"",
            end_date:"",
            start_folio:"",
            end_folio:"",
            check_all:false,
            type:'donations',
            list:[],
            lab_select_doc:{},
            lab_sections:[],
            convoke_place_id:"all",
            convoke_places:[],
            preview_print: {},
        }
    }

    async componentDidMount(){
        var response = await healthFacilitiesGetCriterial(sessionStorage.getItem('health_facilities_id'), 'LAB_SELECT_DOC');

        if(response){
            this.setState({lab_select_doc: response});
        }

        response = await functionalCriterial('lab_preview_print');
		if(response !== undefined){
			this.setState({
				preview_print: response
			});
		}

        response = await labSectionsByHf(sessionStorage.getItem('health_facilities_id'));
        if(response){
            var lab_sections = [];
            response.forEach((res)=>{
                lab_sections.push({
                    section:{
                        id:res.id,
                        name:res.name
                    }
                });
            });

            this.setState({lab_sections: lab_sections});
        }

        response = await convokePlacesOption('all', sessionStorage.getItem('health_facilities_id'));
		if(response !== undefined){
			this.setState({
				convoke_places: response
			});
		}
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});

        if(e.target.name === 'search_type'){
            this.setState({
                start_date:"",
                end_date:"",
                start_folio:"",
                end_folio:"",
            });
        }
    }

    onCheck(e, i){
        var list = this.state.list;
        if(e.target.name === 'check_all'){
            list.forEach((list)=>{
                list.check = e.target.checked
            });

            this.setState({check_all: e.target.checked});
        }else{
            list[i].check = e.target.checked; 
        }

        this.setState({list:list});
    }

    async onSearch(){
        var error = '';
        if(this.state.search_type === 'date'){
            if(this.state.start_date === '' && this.state.end_date === ''){
                error = 'Debe seleccionar una fecha inicial y una fecha final';
            }

            if(!this.dateCompare()){
                error = 'La fecha inicial debe ser mayor o igual a fecha final';
            }

        }else{
            if(this.state.start_folio === '' && this.state.end_folio === ''){
                error = 'Debe seleccionar un folio inicial y un folio final';
            }
        }

        if(error === ''){
            var response = await printingBlock(
                this.state.type,
                sessionStorage.getItem('health_facilities_id'),
                this.state.start_date,
                this.state.end_date,
                this.state.start_folio,
                this.state.end_folio,
                this.state.convoke_place_id,
                this.props.waiting
            );

            if(response){
                response.forEach((res)=>{
                    res.check = false;
                });
                this.setState({list:response});
            }
        }else{
            swal('Error', error, 'error');
        }
    }

    dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

    async onPrint(e, file, sections = null){
        var obj = {
            health_facilities_id:sessionStorage.getItem('health_facilities_id'),
            file_type:file,
            ids:[],
            sections:sections
        };

        var list = this.state.list;
        list.forEach(l => {
            if(l.check){
                obj.ids.push(l.id)
            }
        });

        if(file === 'area_laboratory'){
            if(this.state.lab_select_doc.value !== 'NO'){
                obj.option = 'filter';	
            }
            
        }
       
        var response = await htmlTemplatesPrintResultsInBulk(obj, this.props.waiting);
        if(response){
            if(this.state.preview_print.value === "NO"){
                //PREVIEW
                var fileURL = URL.createObjectURL(response);
                window.open(fileURL);
            }else{
                //PRINTER
                var reader = new FileReader();
                reader.readAsDataURL(response); 
                reader.onloadend = ()=>{
                    var base64data = reader.result;  
                    var aux = base64data.split(',');
                    this.props.socket.send('{"Operacion":"print", "Type":"laboratory", "File": "'+aux[1]+'"}');
                }
            }
        }
    }

    showSectionsPrint(option){
        var list = this.state.list;
        var can_print = 0;
        list.forEach(l => {
            if(l.check){
                can_print++;
            }
        })

        if(can_print > 0){
            this.file_type_modal.handleShow(option);
        }else{
            swal('Error', 'Debe seleccionar por lo menos un elemento de la lista', 'error');
        }
        
    }

    render(){
        const {t} = this.props;
        return(
            <div className="col-xs-12">
        		<div className="route">
          			<h5 className="title_page" >
			            {sessionStorage.getItem('health_facilities_name')} ->
			            {t('sidebar.nav.laboratory.MAIN')} -> 
			            Impresión de Resultados por Bloque
          			</h5>
        		</div>
        
        		<Help 
          			{...this.props}
            		menu={"help_laboratory"} 
            		submenu={"help_print_results_bulk"}  />
                    
                <div className='col-xs-12 form-group'>
                    <div className='form-group'>
                        <div className='col-xs-12 col-sm-1'>
                            <span className='span-min'>Buscar por</span>
                            <select className='form-control input-sm' name="search_type" id="search_type" value={this.state.search_type}
                                onChange={(e)=>this.handleChange(e)}
                            >
                                <option value='date'>Fecha</option>
                                <option value='folio'>Folio</option>
                            </select>
                        </div>
                        {this.state.search_type === 'date' ?
                            <>
                                <div className='col-xs-12 col-sm-2'>
                                    <span className='span-min'>Desde</span>
                                    <input type='date' className='form-control input-sm' name='start_date' id="start_date"
                                        value={this.state.start_date} onChange={(e)=>this.handleChange(e)} />
                                </div>
                                <div className='col-xs-12 col-sm-2'>
                                    <span className='span-min'>Hasta</span>
                                    <input type='date' className='form-control input-sm' name='end_date' id="end_date"
                                        value={this.state.end_date} onChange={(e)=>this.handleChange(e)} />
                                </div>
                            </>    
                        : 
                            <>
                                <div className='col-xs-12 col-sm-2'>
                                    <span className='span-min'>Desde</span>
                                    <input className='form-control input-sm' name='start_folio' id="start_folio"
                                        value={this.state.start_folio} onChange={(e)=>this.handleChange(e)} />
                                </div>
                                <div className='col-xs-12 col-sm-2'>
                                    <span className='span-min'>Hasta</span>
                                    <input className='form-control input-sm' name='end_folio' id="end_folio"
                                        value={this.state.end_folio} onChange={(e)=>this.handleChange(e)} />
                                </div>
                            </>
                        }
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Tipo</span>
                            <select className='form-control input-sm' name="type" id="type" value={this.state.type}
                                onChange={(e)=>this.handleChange(e)}
                            >
                                <option value='donations'>Donantes</option>
                                <option value='samples'>Pacientes</option>
                            </select>
                        </div>
                        <div className='col-xs-12 col-sm-3'>
                            <span className='span-min'>Lugar de Colecta</span>
                            <select className='form-control input-sm' name="convoke_place_id" id="convoke_place_id" value={this.state.convoke_place_id}
                                onChange={(e)=>this.handleChange(e)}
                            >
                                <option value='all'>TODOS</option>
                                {this.state.convoke_places.map((c, i) => (
                                    <option value={c.convoke_places.id} key={i}>{c.convoke_places.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className='col-xs-12 col-sm-2' style={{marginTop:20}}>
                            <button className='btn btn-info' onClick={()=>this.onSearch()}>Buscar</button>
                        </div>
                    </div>
                    <hr style={{width:'90%'}} />
                    <div className='form-group'>
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th>
                                        <input type='checkbox' name="check_all" id="check_all" value={this.state.check_all}
                                            checked={this.state.check_all} onChange={(e)=>this.onCheck(e)} />
                                    </th>
                                    <th>{this.state.type === 'donations' ? 'No. Donación' : 'Muestra'}</th>
                                    <th>Fecha</th>
                                    <th>Lugar de Colecta</th>
                                    <th>{this.state.type === 'donations' ? 'Nombre Donante' : 'Paciente'}</th>
                                    <th>Validación</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((list, i)=>
                                    <tr key={i}>
                                        <td>
                                            <input type="checkbox" checked={list.check} value={list.check} onChange={(e)=>this.onCheck(e, i)} />
                                        </td>
                                        <td>
                                            {list.number}
                                        </td>
                                        <td>
                                            {moment(list.date).format('DD/MM/YYYY')}
                                        </td>
                                        <td>
                                            {list.convoke_place}
                                        </td>
                                        <td>
                                            {list.name}
                                        </td>
                                        <td>{list.status}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    <div className="col-xs-12" style={{textAlign:'center'}}>
                        <button type="button" tittle="" className="btn btn-results" 
							style={{background:'transparent'}}
							onClick={(e)=>this.state.lab_select_doc.value === 'NO' ? 
                                this.showSectionsPrint(false)
							: this.showSectionsPrint(true)}>
							<div style={{textAlign:'center'}}>
								<SvgIcon icon={print} size={25}/>
							</div>
							Imprimir
						</button>
                    </div>
                </div>
                
                <ModalFileType {...this.props} onRef={ref => (this.file_type_modal = ref)} 
					print={this.onPrint} sections={this.state.lab_sections}
                    type={this.state.type}
                    donation_id={
                        this.state.lab_select_doc.value === 'NO' ?
                            this.state.type === 'donations' ? '1' : '0'
                    :
                        '1'
                    } />
            </div>
        )
    }
}

export default translate('translations') (PrintingBlock);